
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SummaryProcessor } from './utils/summary-table-util';

interface DealerSummary {
  dealer: string;
  walkIn: { ytd: number; periodoPrevio: number };
  sales: { ytd: number; periodoPrevio: number };
}

@Component
export default class SummaryTabla extends Vue {
  @Prop({ required: true })
  summaryData!: {
    current_month: Array<{ dealer: string; items: Record<string, any> }>;
    current_past_month: Array<{ dealer: string; items: Record<string, any> }>;
  };

  private dayRange = { start: 1, end: 31 };
  private summaryProcessor: SummaryProcessor;

  currentPage: number = 1;
  itemsPerPage: number = 2;

  constructor() {
    super();
    this.summaryProcessor = new SummaryProcessor(
      this.dayRange,
      this.initializeDays
    );
  }

  private initializeDays() {
    return Array.from({ length: this.dayRange.end }, (_, i) => i + 1)
      .reduce((acc: { [key: number]: number }, day) => {
        acc[day] = 0;
        return acc;
      }, {});
  }

  get processedSummary(): DealerSummary[] {
    this.processDataSources();
    return this.summaryProcessor.getSummary();
  }

  private processDataSources() {
    this.summaryProcessor.processData('current', this.summaryData.current_month);
    this.summaryProcessor.processData('past', this.summaryData.current_past_month);
  }

  get totalPages(): number {
    return Math.ceil(this.processedSummary.length / this.itemsPerPage);
  }

  get paginatedSummary(): DealerSummary[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.processedSummary.slice(start, start + this.itemsPerPage);
  }

  formatDNT(ytd: number, periodoPrevio: number): string {
    if (!periodoPrevio) return '0%';
    const percentage = ((ytd / periodoPrevio - 1) * 100).toFixed(2);
    return `${percentage}%`;
  }

  formatRatio(numerator: number, denominator: number): string {
    if (!denominator) return '0%';
    const percentage = ((numerator / denominator) * 100).toFixed(2);
    return `${percentage}%`;
  }
}
